"use strict";
/**
 *
 * FormState/selectors
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
exports.defaultValuesSelector = ({ defaultValues }) => defaultValues;
exports.makeDefaultValueSelector = (path) => ({ defaultValues, }) => get_1.default(defaultValues, path);
exports.valuesSelector = ({ values }) => values;
exports.makeValueSelector = (path) => ({ values, }) => get_1.default(values, path);
exports.submittingSelector = ({ submitting }) => submitting;
exports.submitErrorSelector = ({ submitError }) => submitError;
exports.disabledSelector = ({ disabled }) => disabled;
exports.readOnlySelector = ({ readOnly }) => readOnly;
exports.fieldsSelector = ({ fields }) => fields;
exports.changedSelector = ({ fields }) => Object.keys(fields).some((key) => fields[key].changed);
exports.invalidSelector = ({ fields }) => Object.keys(fields).some((key) => fields[key].validityMessage !== null);
exports.lockedSelector = (state) => {
    const disabled = exports.disabledSelector(state);
    if (disabled) {
        return true;
    }
    const readOnly = exports.readOnlySelector(state);
    if (readOnly) {
        return true;
    }
    const submitting = exports.submittingSelector(state);
    if (submitting) {
        return true;
    }
    return !exports.changedSelector(state);
};
